import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=1242869c&"
import script from "./LoginLayout.vue?vue&type=script&lang=js&"
export * from "./LoginLayout.vue?vue&type=script&lang=js&"
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=1242869c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1242869c')) {
      api.createRecord('1242869c', component.options)
    } else {
      api.reload('1242869c', component.options)
    }
    module.hot.accept("./LoginLayout.vue?vue&type=template&id=1242869c&", function () {
      api.rerender('1242869c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/LoginLayout.vue"
export default component.exports